module.exports = __webpack_public_path__ + "img/senderrand-business-load.b8ae4c8c.png";